export const access_cookie = "ab6a937a-6c55-11eb-9439-0242ac130002";
export const user = "ab6a937a-6c55-11eb-9439-0242ac130001";
